import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { addDays, addMonths, addYears } from "date-fns";
import CustomTable from "../../../../../customComponents/CustomTable";
import moment from "moment";

const AddExtendWarranty = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [itemLabel, setItemLabel] = useState([]);
  const [itemtypedd, setItemTypeDD] = useState([]);
  const [warrantyTypeData, setWarrantyTypeData] = useState([]);
  const [itemTypeData, setItemTypeData] = useState([]);

  const [totalJobRecord, setTotalJobRecord] = useState(null);

  


  // List states 
  const [jobCardList, setJobCardList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [filterList, setFilterList] = useState();
  const [totalRecords, setTotalRecored] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [filters, setFilters] = useState({});


  const [ vinOptions  ,  setVinOptions] = useState([])

  const [ poListIdVal , setPoListIdVal ] = useState(0)
  const [ poListIdDetailsVal , setPoListIdDetailsVal ] = useState(0)

  const [ tableDataVal , setTableDataVal ] = useState([])



  const [warrantycategory, setWarrantyCategory] = useState([]);

  useEffect(() => {
    warrantyType();
    warrantyCategory();
  }, []);
  const warrantyCategory = async () => {
    try {
      const response = await axiosInstance.post(
        "/warrantytype/ddlwarrantycategory",
        {},  // Add an empty object here for the request body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
  
      const data = response.data.data.data;
      const warrantycategoryoptions = data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      setWarrantyCategory(warrantycategoryoptions);
    } catch (error) {
      console.log(error);
    }
  };

  const ItemListDropdown = async () => {
    try {
      const response = await axiosInstance.post(
        "/variant/ddltypebaseproduct",
        { itemtype_id: formData?.itemtype },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = response.data.data.data;
      const itemTypeOptions = data.map((item) => ({
        value: item.ID,
        label: item.NAME,
      }));
      setItemTypeDD(itemTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    itemType();
  }, []);

  // useEffect(() => {
  //   warrantyType();
  //   console.log("warrantyTypeData", warrantyTypeData);
  // }, [formData?.item_id]);

  useEffect(() => {
    warrantyType();
  },[formData.warrantycategory])

  const itemType = async () => {
    try {
      const response = await axiosInstance.get("/itemtype/ddlitemtype", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const itemTypeOptions = data.map((item) => ({
        value: item.ID,
        label: item.NAME,
      }));
      setItemTypeData(itemTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const warrantyType = async () => {
    try {
      const response = await axiosInstance.post(
        "/warrantytype/ddlwarrantytype",
        {},  // Add an empty object here for the request body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
  
      const data = response.data.data.data;
      const warrantyTypeOptions = data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      setWarrantyTypeData(warrantyTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const currentDate = new Date().toISOString().split("T")[0];

  // Set current date only if it hasn't been set yet
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      warrantyFrom:  currentDate,
    }));
  }, [currentDate]);


  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const confirmation = await Swal.fire({
      title: "Add Warranty",
      text: "Are you sure you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
    if (confirmation.isConfirmed) {
      try {
        setLoading(true);

        let kilometer = null;
      let warrantyDays = 0;

      if (formData.warranty_category === "km") {
        kilometer = formData.warranty_value; // Store kilometer value if category is 'km'
      } else if (formData.warranty_category === "Y" && formData.warranty_type) {
        switch (formData.warranty_type) {
          case "Y":
            warrantyDays = formData.warranty_value * 365;
            break;
          case "M":
            warrantyDays = formData.warranty_value * 30;
            break;
          case "D":
            warrantyDays = parseInt(formData.warranty_value, 10);
            break;
          default:
            warrantyDays = 0;
        }
      }

      console.log("Kilometer:", kilometer); // Log kilometer value for debugging
      console.log("Warranty Days:", warrantyDays); // Log warranty days for debugging


        const payload = {
          polistId: poListIdVal,
          podetailsId: poListIdDetailsVal,
          postockinId: formData.postockinId,
          warrantyFrom: formData.warrantyFrom,
          warrantycost: formData.warrantycost,
          warranty_value: formData.warranty_value,
          warranty_category: formData?.warranty_category,
          warranty_type: formData?.warranty_type,
          warrantyTo:formData?.warrantyTo || null,
          remark:formData?.remark,
          // status: formData.status === true ? 1 : 0,
          kilometer: kilometer || null, 
          warrantyDay: warrantyDays.toString(), 
        };

        const response = await axiosInstance.post(
          "/extendedwarranty/create",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        await Swal.fire({
          title: "Success",
          text: "Warranty added successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });
        if (response.status === 200) {
          navigate("/admin/manage-warranty/extend-warranty");
          setFormData({})
        }
      } catch (error) {
        console.error("Error adding warranty:", error);
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred while processing your request.";
        await Swal.fire({
          title: "Something went wrong",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const backNavigate = () => {
    navigate("/admin/manage-warranty/extend-warranty");
  };

  useEffect(() => {
    ItemListDropdown();
    setItemLabel(
      formData?.itemtype == 1
        ? "Spare Part"
        : formData?.itemtype == 2
        ? "Accessory"
        : "Variant"
    );
  }, [formData?.itemtype]);

  useEffect(() => {
    fetchVinDetails()
  },[])

  const fetchVinDetails = async (custId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/extendedwarranty/ddlvinandsrno",
        {
          // business_partner_id,
          // customer_id: custId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setVinOptions(options)

      // if (options.length > 0) {
      //   setFormData((prevData) => ({
      //     ...prevData,
      //     lead_id: options[0].value, 
      //   }));
      // }

      // setCustomerDDl(options);
      console.log(options, "leadOPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  }

  useEffect(() => {
    const leadId = formData.postockinId;
    console.log(leadId, "leadId")
    if(leadId){
      fetchDetailsAgainsVin(leadId);
      // setLeadCodeOptions([])
    }
  }, [formData.postockinId]);

  useEffect(() => {
    const leadId = formData.postockinId;
    console.log(leadId, "leadId")
    if(leadId){
      fetchDetailsAgainsVinTable(leadId);
      // setLeadCodeOptions([])
    }
  }, [formData.postockinId]);

  const fetchDetailsAgainsVinTable = async (leadId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.get(
        `/extendedwarranty/getvinandsrnowarrantylist/${leadId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const tableData = response.data.data.vindetails
      setTableDataVal(tableData)

    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };


  const fetchDetailsAgainsVin = async (leadId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.get(
        `/extendedwarranty/getvinandsrnobasedetail/${leadId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
  
      const fetchedData = response.data.data[0];
      console.log(fetchedData, "FETCHEDCUSTDATA");



      const poListId = fetchedData.po_id

      setPoListIdVal(poListId)

      const poDetailsId = fetchedData.po_details_id

      setPoListIdDetailsVal(poDetailsId)


  
      const formatedData = {
        variant: fetchedData.variant_name,
        model: fetchedData.model_name,
        product_id: fetchedData.product_id,
        subproduct_id: fetchedData.subproduct_id,
        make_id: fetchedData.make_id,
        model_id: fetchedData.model_id,
        variant_id: fetchedData.variant_id,
        color_id: fetchedData.color_id,
        fueltype_id: fetchedData.fuel_type_id,
        exshowroomprice: fetchedData.exshowroom_price,
        custsubsidyprice:fetchedData.subsidyprice
      };

      
  
      setFormData((prevData) => ({
        ...prevData, // Preserve existing form data
        ...formatedData // Merge new vehicle data
      }));
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  const CustomerInputs = [
    {
      name: "postockinId",
      label: "Vin No.",
      type: "dropdown",
      required: true,
      options: vinOptions,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    // {
    //   name: "item_id",
    //   label: itemLabel,
    //   type: "dropdown",
    //   required: true,
    //   options: itemtypedd,
    //   validation: { required: true },
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "productType",
    //   label: "Product Type",
    //   type: "dropdown",
    //   required: true,
    //   options: itemtypedd,
    //   validation: { required: true },
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "make",
    //   label: "Make",
    //   type: "dropdown",
    //   required: true,
    //   options: itemtypedd,
    //   validation: { required: true },
    //   gridClass: "col-lg-4",
    // },
    {
      name: "model",
      label: "Model",
      type: "text",
      required: true,
      // options: itemtypedd,
      validation: { required: true },
      gridClass: "col-lg-4",
      disabled:"true"
    },
    {
      name: "variant",
      label: "Variant",
      type: "text",
      required: true,
      // options: itemtypedd,
      validation: { required: true },
      gridClass: "col-lg-4",
       disabled:"true"
    },
    {
      name: "warranty_category",
      label: "Warranty Category",
      type: "dropdown",
      required: true,
      options: warrantycategory,
      placeholder: "Warranty Category",
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    ...(formData?.warranty_category === "Y"
      ? [
          {
            name: "warranty_type",
            label: "Warranty Type",
            placeholder: "Enter Warranty Value",
            type: "dropdown",
          options: warrantyTypeData,
            required: true,
            validation: { required: true },
            gridClass: "col-lg-4",
          },
        ]
      : []),

    {
      name: "warranty_value",
      label: "Warranty Value",
      placeholder: "Enter Warranty Value",
      type: "number",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    // {
    //   name: "extwarrantyname",
    //   label: "Extended Warranty Name",
    //   placeholder: "Enter Extended Warranty Name",
    //   type: "text",
    //   required: true,
    //   validation: { required: true },
    //   gridClass: "col-lg-4",
    // },

    // {
      //   name: "extwarrantycost",
      //   label: "Extended Warranty Cost",
      //   type: "text",
    //   placeholder: "Enter Cost",
    //   required: true,
    //   validation: { required: true },
    //   gridClass: "col-lg-4",
    // },
    {
      name: "warrantyFrom",
      label: "Warranty From",
      placeholder: "Trans. Date",
      type: "date",
      gridClass: "col-lg-4",
      // disabled: true,
    },
    {
      name: "warrantyTo",
      label: "Warranty To",
      placeholder: "Trans. Date",
      type: "date",
      gridClass: "col-lg-4",
      disabled: true,
    },
    {
      name: "warrantycost",
      label: "Warranty Cost",
      placeholder:"Enter Warranty Cost",
      type: "text",
      required: true,
      // options: itemtypedd,
      validation: { required: true },
      gridClass: "col-lg-4",
      //  disabled:"true"
    },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      required: true,
      placeholder:"Enter Remark",
      // options: itemtypedd,
      validation: { required: true },
      gridClass: "col-lg-4",
      //  disabled:"true"
    },
    // {
    //   name: "warranty_desc",
    //   label: "Warranty Description",
    //   type: "text",
    //   placeholder: "Enter Warranty Description",
    //   required: true,
    //   validation: { required: true },
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "status",
    //   label: "Status",
    //   type: "toggle",
    //   gridClass: "col-lg-4",
    // },
  ];

  useEffect(() => {
    if (
      formData.warranty_category === "Y" &&
      formData.warranty_type &&
      formData.warranty_value &&
      formData.warrantyFrom
    ) {
      const startDate = new Date(formData.warrantyFrom);
      let warrantyDays = 0;

      switch (formData.warranty_type) {
        case "Y":
          warrantyDays = formData.warranty_value * 365;
          break;
        case "M":
          warrantyDays = formData.warranty_value * 30;
          break;
        case "D":
          warrantyDays = parseInt(formData.warranty_value, 10);
          break;
        default:
          warrantyDays = 0;
      }

      console.log("Warranty Days:", warrantyDays);

      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + warrantyDays);

      setFormData((prev) => ({
        ...prev,
        warrantyTo: endDate.toISOString().split("T")[0], // Format as YYYY-MM-DD
        kilometer: "", // Reset kilometer when warranty_category is "Y"
      }));
    } else if (formData.warranty_category === "km" && formData.warranty_value) {
      console.log("Kilometer Value:", formData.warranty_value)
      setFormData((prev) => ({
        ...prev,
        warrantyTo: "", // Reset warrantyTo when warranty_category is "km"
        kilometer: formData.warranty_value, // Store the kilometer value
      }));
    }
  }, [
    formData.warranty_category,
    formData.warranty_type,
    formData.warranty_value,
    formData.warrantyFrom,
  ]);

  const Job_Card_TABLE_HEADERS = [
    "Vin No.",
    // "Business Partner ID",
    "Warranty Type",
    "Warranty Value",
    "Warranty Category",
    "Type",
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Vin No.": "vin_no",
    // "Business Partner ID": "onboard_id",
    "Warranty Type": "warranty_type",
    "Warranty Value": "warranty_value",
    "Warranty Category": "warranty_category",
    "Type":"Type",
    // "Print": "Print"
  };

  const fetchJobCardList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    const payload= {
      // business_partner_id: 1,
      orderBy: "job_card_id desc",
      page,
      pageSize,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      toDate: allfilteredData?.toDate ? allfilteredData?.toDate : "",
      // searchText: searchTerm,
    }
    try {
      // setTableLoader(true)
      const response = await axiosInstance.post(
        "/jobcard/list",payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      // setTableLoader(false)
      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        status: item?.status === 0 ? "Pending" : "Done",
        // job_card_no: onClickNavigetion(item),
        transaction_date: moment(item?.transaction_date).format("DD/MM/YYYY"),

        isApproved: item?.isApproved == 0 ? "Inactive" : "Active",
      }));
      if (response?.status == 200) {
        setJobCardList(formattedData);
        setTotalRecored(response?.data?.data?.totalRecords);
        setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
        setTotalJobRecord(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
          <div style={{display:"flex", justifyContent:"space-between"}}>
            <div className="backbutton mt-2 mb-2">
              <img onClick={backNavigate} src={backicon} alt="back" />
              <span className="backbtntitle">Add Extended Warranty</span>
            </div>
            <div style={{marginRight:"15px", display:"flex", alignItems:"center", gap:"10px"}} className="btncontainer mt-3">
              <button
              style={{paddingLeft:"40px", paddingRight:"40px"}}
                className="clear-btn"
                onClick={backNavigate}
              >
                Back
              </button>
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btnn"
              >
                Submit
              </button>
            </div>
          </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please enter extended warranty details
              </span>
              <DynamicForm
                formConfig={CustomerInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                // apiCall={apiCall}
              />
            </div>

            <CustomTable
          data={tableDataVal}
          headers={Job_Card_TABLE_HEADERS}
          keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
          // onEdit={handleEdit}
          // handleViewButton={handleViewButton} // Pass the handleEdit function
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          // onPageChange={handlePageChange}
        //  handleClicableRow={handleClicableRow}
          // pdfDownLoad={DownLoadPdf}
          totalRecords={totalRecords}
          // tableLoaderShow={tableLoader}
        />

            
          </>
        )}
      </div>
    </>
  );
};

export default AddExtendWarranty;
